module.exports = __webpack_public_path__ + "static/media/ic-facebook.29772836.svg";